module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "register_wrapper"
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "left"
  }, [_c('Form', {
    ref: "formCustom",
    attrs: {
      "model": _vm.formCustom,
      "rules": _vm.ruleCustom,
      "label-width": 120,
      "autocomplete": "off"
    }
  }, [_c('FormItem', {
    attrs: {
      "label": "用户名",
      "prop": "loginName"
    }
  }, [_c('Input', {
    attrs: {
      "type": "text",
      "maxlength": 11,
      "placeholder": "手机号或数字或字母（6-11位）"
    },
    on: {
      "input": _vm.fastInput
    },
    model: {
      value: (_vm.formCustom.loginName),
      callback: function($$v) {
        _vm.$set(_vm.formCustom, "loginName", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "formCustom.loginName"
    }
  })], 1), _vm._v(" "), _c('FormItem', {
    attrs: {
      "label": "手机号码",
      "prop": "phone"
    }
  }, [_c('Select', {
    staticStyle: {
      "width": "120px"
    },
    attrs: {
      "size": "small",
      "placeholder": "",
      "transfer": true
    },
    on: {
      "on-change": _vm.phoneNumChange
    },
    model: {
      value: (_vm.formCustom.phoneNum),
      callback: function($$v) {
        _vm.$set(_vm.formCustom, "phoneNum", $$v)
      },
      expression: "formCustom.phoneNum"
    }
  }, [_c('Option', {
    attrs: {
      "value": "86"
    }
  }, [_vm._v("中国大陆+86")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "886"
    }
  }, [_vm._v("中国台湾+886")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "852"
    }
  }, [_vm._v("中国香港+852")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "853"
    }
  }, [_vm._v("中国澳门+853")])], 1), _vm._v(" "), _c('Input', {
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "type": "text",
      "placeholder": "请输入手机号码",
      "maxlength": _vm.phoneMaxLength
    },
    on: {
      "input": _vm.fastInputPhone
    },
    model: {
      value: (_vm.formCustom.phone),
      callback: function($$v) {
        _vm.$set(_vm.formCustom, "phone", _vm._n($$v))
      },
      expression: "formCustom.phone"
    }
  }), _vm._v(" "), (!_vm.showSec) ? _c('div', {
    staticClass: "getcode",
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": _vm.phoneCode
    }
  }, [_vm._v("获取验证码")]) : _c('div', {
    staticClass: "seconds"
  }, [_vm._v("已发送 (" + _vm._s(_vm.seconds) + "S)")])], 1), _vm._v(" "), _c('FormItem', {
    attrs: {
      "label": "登录密码",
      "prop": "pwd"
    }
  }, [_c('Input', {
    attrs: {
      "type": "password",
      "placeholder": "请设置登录密码"
    },
    model: {
      value: (_vm.formCustom.pwd),
      callback: function($$v) {
        _vm.$set(_vm.formCustom, "pwd", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "formCustom.pwd"
    }
  })], 1), _vm._v(" "), _c('FormItem', {
    attrs: {
      "label": "验证码",
      "prop": "code"
    }
  }, [_c('Input', {
    attrs: {
      "type": "text",
      "placeholder": "请输入验证码"
    },
    model: {
      value: (_vm.formCustom.code),
      callback: function($$v) {
        _vm.$set(_vm.formCustom, "code", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "formCustom.code"
    }
  })], 1), _vm._v(" "), _c('FormItem', {
    staticClass: "recommend-item",
    attrs: {
      "label": "推荐人账号"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "请输入推荐人账号（非必填）",
      "type": "text",
      "disabled": _vm.recommendDisable
    },
    on: {
      "on-blur": _vm.getNoLoginUserInfo
    },
    model: {
      value: (_vm.formCustom.recommendLoginName),
      callback: function($$v) {
        _vm.$set(_vm.formCustom, "recommendLoginName", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "formCustom.recommendLoginName"
    }
  }), _vm._v(" "), (_vm.recommendName) ? _c('div', {
    staticClass: "recommend-name"
  }, [_vm._v(_vm._s(_vm.recommendName))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "getcode",
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": _vm.recommendEdit
    }
  }, [_vm._v("修改")])], 1), _vm._v(" "), _c('FormItem', [_c('Checkbox', {
    attrs: {
      "size": "large"
    },
    model: {
      value: (_vm.formCustom.checked),
      callback: function($$v) {
        _vm.$set(_vm.formCustom, "checked", $$v)
      },
      expression: "formCustom.checked"
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-size": "14px"
    }
  }, [_vm._v("注册账号即表示您同意并愿意遵守开心云商"), _c('span', {
    staticStyle: {
      "cursor": "pointer",
      "color": "#1F7BF5"
    },
    on: {
      "click": function($event) {
        return _vm.provisionHandle(1)
      }
    }
  }, [_vm._v("用户协议")]), _vm._v("和"), _c('span', {
    staticStyle: {
      "cursor": "pointer",
      "color": "#1F7BF5"
    },
    on: {
      "click": function($event) {
        return _vm.provisionHandle(2)
      }
    }
  }, [_vm._v("隐私政策")])])], 1), _vm._v(" "), _c('FormItem', [_c('Button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.formCustom.checked),
      expression: "formCustom.checked"
    }],
    staticClass: "regis_ent m_register",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.handleSubmit('formCustom')
      }
    }
  }, [_vm._v("注册新用户")]), _vm._v(" "), _c('Button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.formCustom.checked),
      expression: "!formCustom.checked"
    }],
    staticStyle: {
      "width": "120px",
      "height": "36px",
      "display": "flex",
      "align-items": "center",
      "justify-content": "center",
      "font-size": "14px"
    },
    attrs: {
      "disabled": "",
      "type": "primary"
    }
  }, [_vm._v("注册新用户")])], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "middle"
  }), _vm._v(" "), _c('div', {
    staticClass: "right"
  }, [_c('p', [_vm._v("已有账号？请直接登录")]), _vm._v(" "), _c('router-link', {
    staticClass: "regis_ent",
    attrs: {
      "to": "/login",
      "title": "会员登录"
    }
  }, [_vm._v("立即登录")])], 1), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h1', [_vm._v("请注册"), _c('span', [_vm._v("欢迎注册会员！")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3f429d16"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/register/index.vue
// module id = 1582
// module chunks = 1